export default {"src":"/org/_next/static/media/check-white.9511ca89.svg","height":16,"width":17,"blurWidth":0,"blurHeight":0};